import { render, staticRenderFns } from "./AuthorizedDevices.vue?vue&type=template&id=3bf083cc&"
import script from "./AuthorizedDevices.vue?vue&type=script&lang=js&"
export * from "./AuthorizedDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports